import React from 'react';
import { usePearlModal } from 'framework';
import EmailVerificationPanel from './EmailVerificationPanel';
import { VerifyEmailModalShell } from './EmailVerificationPanel.styled';

const VerificationModalContent = ({ onVerify, email }) => {
    const { closeModal } = usePearlModal();

    return (
        <VerifyEmailModalShell data-testid="modal-container">
            <EmailVerificationPanel
                email={email}
                onVerified={() => {
                    onVerify?.();
                    closeModal();
                }}
            />
        </VerifyEmailModalShell>
    );
};

export default VerificationModalContent;
